export const testimonials = [
  {
    name: 'Dr. Sarah Mitchell',
    country: 'United States',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8449ea09-401b-4d7c-b076-bb4079d4813d.jpg',
    quote:
      'Having the warning signs organized in one system makes it much easier to review a difficult case before surgery.',
  },
  {
    name: 'Dr. James Whitfield',
    country: 'United Kingdom',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/5f6f1270-7e9f-4abf-aec6-7dee8fdcf785.jpg',
    quote:
      'I especially liked the Stop, Reassess, Decide framework. It gave me a much more structured way to think about unexpected findings.',
  },
  {
    name: 'Dr. Priya Raman',
    country: 'Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/d42c2a2d-7d46-4166-a249-1f60ac98a01c.jpg',
    quote: 'The checklists became part of my preparation routine for more complex implant cases.',
  },
  {
    name: 'Dr. Marcus Bennett',
    country: 'Australia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e5533950-4cb6-4a47-a9da-5459c9954100.jpg',
    quote:
      "This isn't just another collection of theory. It's organized around what you actually need to notice and reassess.",
  },
  {
    name: 'Dr. Karen Holloway',
    country: 'Ireland',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/5848d78c-0631-425c-8a0d-384893212129.jpg',
    quote:
      'The Risk Radar concept helped me think about complications differently: not just as things that happen, but as situations where there may be warning signals worth recognizing earlier.',
  },
];
